import React from 'react';

const Menussadi = () => {
    return (
        <section className='wpo-blog-pg-section section-padding'>
            <div className='container'>
                <div className='row'>
                    <h1 style={{textAlign:"center"}}> Bientôt Disponible !</h1>
                </div>
            </div>
        </section>
    );
}

export default Menussadi;
